// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"598":"e903f190","703":"ad1d155e","787":"cda612ba"}[chunkId] + ".chunk.js";
};